import Intercom from '@intercom/messenger-js-sdk';
import Config from '../config/Config.js';
import ConfigBusiness from '../config/ConfigBusiness.js';

/**
 * Encapsula la inicialización de Intercom para VecFleet.
 *
 * Consume el endpoint backend `/usuarios/init-intercom` para obtener el contrato
 * Contact (app_id, role, external_id, name, email, signed_up_at, companies)
 * y lo traduce al formato del Messenger JS SDK (`Intercom({...})`).
 *
 * Punto de entrada único: `IntercomBoot.boot()`.
 */
class IntercomBoot {
  static isEnabled() {
    return ConfigBusiness.get("intercom.frontend.intercom_enabled") === "true";
  }

  static boot() {
    if (!this.isEnabled()) {
      return;
    }

    fetch(Config.get("apiUrlBase") + '/usuarios/init-intercom', {
      method: "GET",
      headers: {
        "Authorization-Token": localStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (!response.ok) {
          return response.text().then((body) => {
            throw new Error('init-intercom HTTP ' + response.status + ' ' + (body || '<empty body>'));
          });
        }
        return response.json();
      })
      .then((data) => this.bootWith(data))
      .catch((err) => {
        console.error('Intercom init failed:', err);
      });
  }

  static bootWith(data) {
    if (!data.app_id) {
      console.error('Intercom boot skipped: missing app_id in payload', data);
      return;
    }
    if (!data.external_id) {
      console.error('Intercom boot skipped: missing external_id in payload', data);
      return;
    }

    const userLocale = (localStorage.getItem("userLocale") || "").split("-")[0];
    const companies = (data.companies || []).map(function (company) {
      return {
        company_id: company.company_id,
        name: company.name
      };
    });

    const settings = {
      app_id: data.app_id,
      user_id: data.external_id,
      name: data.name,
      email: data.email,
      created_at: data.signed_up_at,
      language_override: userLocale,
      companies: companies
    };

    try {
      Intercom(settings);
    } catch (err) {
      console.error('Intercom boot failed:', err, settings);
    }
  }
}

export default IntercomBoot;
